import { apiClient } from '@/api/client';

/**
 * Download a job file at full quality.
 *
 * The presigned URL carries an attachment disposition and the real filename, so
 * navigating to it downloads without leaving the page — and without pulling a
 * 20MB original through JS memory the way a blob download would. `original`
 * falls back to the display rendition server-side when no original landed.
 */
export async function downloadJobFile(jobId: string, fileId: string): Promise<void> {
  const { url } = await apiClient.get<{ url: string }>(`/jobs/${jobId}/files/${fileId}/download`, {
    params: { variant: 'original' },
  });
  window.location.href = url;
}
